interface GatewayCheckoutProps {
  checkoutUrl: string;
  onIFrameRedirectionToHost: (orderId: string | null) => void;
}

const GatewayCheckout = ({ checkoutUrl, onIFrameRedirectionToHost }: GatewayCheckoutProps) => {
  const onIframeNavigation = (event: any) => {
    const iframe = event.target;

    try {
      if (iframe.contentWindow?.location?.origin === window.location.origin) {
        setTimeout(() => {
          const url = new URL(iframe.contentWindow.location);
          const orderId = url.searchParams.get('orderId');

          onIFrameRedirectionToHost(orderId);
        }, 1000);
      }
    } catch (error) {
      console.error('Error in onIframeNavigation', error);
    }
  };

  return (
    <iframe
      src={checkoutUrl}
      onLoad={onIframeNavigation}
      allow="fullscreen"
      data-testid="gateway-checkout-iframe"
      className="h-[80dvh] w-full rounded-md vt-utility-white sm:h-[75dvh]"
    />
  );
};

export default GatewayCheckout;
